export class AreaMappatureModel {
  public roles: [];
  public notes: string;
}
